module.exports = __webpack_public_path__ + "img/badge.47b08f9.svg";